import {
  TpDataObject,
  TpETLTableColumn,
  TpDataObjectTable,
  TpDataObjectMatrix,
  TpETLObjectTypes,
} from './etl-data-types/interfaces';

// ************************ ETL PIPELINE *************************

export interface TpETLPipelineComponent {
  id: string;
  name: string;
  componentType: string;
  inputObjectIds: { [id: string]: string };
  extraParamObjectIds: string[];
  outputObjectIds: { [id: string]: string };
  params: { [id: string]: any };
}

export interface TpETLPipeline {
  components: TpETLPipelineComponent[];
  componentMap: { [id: string]: TpETLPipelineComponent };
}

// ************************ DRY RUN RELATED *************************

export interface TpETLDryRunObjectBase {
  id: string; // unique identifier of the data object
  createdByCompId: string; // component that created this object
}

export type TpETLDryRunObject = TpETLDryRunObjectBase & TpDataObject;

// For specific types:
export type TpETLDryRunTableObject = TpETLDryRunObjectBase & TpDataObjectTable;
export type TpETLDryRunMatrixObject = TpETLDryRunObjectBase & TpDataObjectMatrix;

export function isDryRunMatrixObject(obj: TpETLDryRunObject): obj is TpETLDryRunMatrixObject {
  return obj.type === TpETLObjectTypes.MATRIX;
}

export interface TpETLDryRunComponentResult {
  // Result of a single component dry run execution
  abort: boolean; // if true, the execution critically failed, without ability to continue
}

export interface TpETLDryRunError {
  compId: string; // component where the error happened
  paramId?: string; // if applicable, the parameter of that component
  message: string; // error message
}

export interface TpETLDryRun {
  // Contains the information collected during a pipeline dry run
  pipeline: TpETLPipeline;
  objectsMap: { [id: string]: TpETLDryRunObject }; // data objectes created
  errors: TpETLDryRunError[]; // errors accumulated
}

// ************************ DATA CONTEXT RELATED *************************

export interface TpETLEntityTableObject {
  dataObjectId: string;
  name: string;
  description: string;
  entityType: string;
  columns: TpETLTableColumn[];
}

export interface TpETLDataContext {
  assetId: string;
  assetName: string;
  id: string;
  dataTables: TpETLEntityTableObject[];
}
